import {registerEvents} from "@puppycad/cad-core";

/**
 * ui相关的事件
 */
const uiEvents = [
    "toolbarSwitchTab",
];

/**
 * 注册事件
 */
registerEvents([
    ...uiEvents
]);